import { PropertySubTypeDTO } from "./propertySubTypeDTO";

export class PropertyTypeDTO{
    public id!:number;
    public name!:string;
    public subTypeList?:PropertySubTypeDTO[];
}